import React, { FC } from 'react';
import { Achievement } from 'components/achievement/Achievement';
import { home } from 'texts/texts';
import { TextWithStyle } from 'components/TextWithStyle';
import './Hero.css';
import './LogoMarquee.css';
import { motion } from "framer-motion"

export const Hero: FC = () => {
  const handleAchievementClick = () => {
    // window.open('https://www.linkedin.com/company/toastie/', '_blank');
  };

  const appStoreLink = 'https://apps.apple.com/au/app/toastie-health-tracker/id6736644572';
  const appStoreSrc = `${process.env.PUBLIC_URL}/assets/appDownload/AppStore.png`;

  const playStoreLink = 'https://play.google.com/store/apps/details?id=au.toastie.health.tracker&hl=en_AU&pli=1';
  const playStoreSrc = `${process.env.PUBLIC_URL}/assets/appDownload/PlayStore.png`;

  const awsSrc = `${process.env.PUBLIC_URL}/assets/supporters/AWS-logo.png`;
  const buildersClubSrc = `${process.env.PUBLIC_URL}/assets/supporters/Builders-Club-logo.png`;
  const heroImageSrc = `${process.env.PUBLIC_URL}/assets/hero-image.svg`;
  const investmentNSWSrc = `${process.env.PUBLIC_URL}/assets/supporters/Investment-NSW-logo.png`;
  const nswGovSrc = `${process.env.PUBLIC_URL}/assets/supporters/NSW-Government-logo.png`;
  const pcosSrc = `${process.env.PUBLIC_URL}/assets/supporters/PCOS-logo.png`;
  const unswSrc = `${process.env.PUBLIC_URL}/assets/supporters/UNSW-logo.png`;
  const googleCloudSrc = `${process.env.PUBLIC_URL}/assets/supporters/GoogleCloud-logo.png`;
  const onePitchSrc = `${process.env.PUBLIC_URL}/assets/supporters/OnePitchVC-logo.png`;
  const goodDesignSrc = `${process.env.PUBLIC_URL}/assets/supporters/GoodDesign-logo.png`;
  const pwdaSrc = `${process.env.PUBLIC_URL}/assets/supporters/PWDA-logo.png`;
  const supporterLogos = [
    { src: goodDesignSrc, alt: 'Good Design' },
    { src: unswSrc, alt: 'UNSW' },
    { src: nswGovSrc, alt: 'NSW government' },
    { src: investmentNSWSrc, alt: 'Investment NSW' },
    { src: awsSrc, alt: 'AWS' },
    { src: buildersClubSrc, alt: 'The Builders Club' },
    { src: googleCloudSrc, alt: 'Google Cloud' },
    { src: pcosSrc, alt: 'PCOS Awareness Association' },
    { src: pwdaSrc, alt: 'PWDA' },
    { src: onePitchSrc, alt: 'OnePitch VC' },
  ];

  return (
    <div className="hero-section">
      <div className="home-content-container">
        <section className='hero'>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className='hero-text'>
              <div className="eyebrow">
                <span className="eyebrow-dot"></span>
                  Chronic illness · health tracking
              </div>
            <h1>
              {home.welcomeMessage.map((part, index) => (
                <TextWithStyle key={index} text={part.text} style={part.style} />
              ))}
            </h1>
            <div>
              <p><b>{home.catchphrase}</b> {home.introduction}</p>
            </div>
            <div className="download-buttons">
              <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
                <motion.img whileHover={{ scale: 1.1 }}
                  src={appStoreSrc}
                  alt="Download on the App Store"
                  className="download-button"
                />
              </a>
              <a href={playStoreLink} target="_blank" rel="noopener noreferrer">
                <motion.img whileHover={{ scale: 1.1 }}
                  src={playStoreSrc}
                  alt="Get it on Google Play"
                  className="download-button"
                />
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 50 }}
            className='hero-image'>
            <img src={heroImageSrc} alt='Hero' />
          </motion.div>
        </section>

        <section className='achievements'>
          {home.achievements.map((achievement, index) => (
            <Achievement
              key={index}
              icon={achievement.icon}
              title={achievement.title}
              description={achievement.description}
              onClick={handleAchievementClick}
            />
          ))}
        </section>

        <section className='supporters'>
          <p>{home.supporters}</p>
          <div className="marquee">
            <div className="marquee-track">
              <div className="marquee-group">
                {[...Array(3)].flatMap((_, i) =>
                  supporterLogos.map((logo, index) => (
                    <div key={`group1-${i}-${index}`} className="item"><img src={logo.src} alt={logo.alt} /></div>
                  ))
                )}
              </div>

              <div className="marquee-group">
                {[...Array(3)].flatMap((_, i) =>
                  supporterLogos.map((logo, index) => (
                    <div key={`group2-${i}-${index}`} className="item"><img src={logo.src} alt={logo.alt} /></div>
                  ))
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
};
